import React, { useState, useContext } from 'react';
import clsx from 'clsx';
import {
    Box,
    Button,
    TextField,
    Grid,
    makeStyles,
    Chip,
    CircularProgress, RadioGroup, Radio, FormLabel,
} from '@material-ui/core';
import { useTranslation } from "react-i18next";
import SecureFetchContext from 'context/SecureFetchContext';
import AppContext from 'context/AppContext';
import getApiRoute from 'routes/apiRoutes';
import Alert from '@material-ui/lab/Alert';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(() => ({
    root: {
    }
}));

const ComplaintFormPacketa = ({ className, data, ...rest }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const secureFetch = useContext(SecureFetchContext);
    const { appValues } = useContext(AppContext);
    const [values, setValues] = useState({
        email: appValues.user.address ? appValues.user.address.email : "",
        shipment_service: 'location_shipment',
    });
    const [sending, setSending] = useState(false);

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setSending(true);

        const formData = new FormData();
        if (data.type === 'damaged_shipment'){
            formData.append('message', values.message);
        } else {
            switch (values.shipment_service) {
                case 'location_shipment':
                    formData.append('message', 'Kde je zásielka');
                    break;
                case 'data_change':
                    formData.append('message', 'Zmena údajov');
                    break;
                case 'cod':
                    formData.append('message', 'Dobierka');
                    break;
                case 'complaint':
                    formData.append('message', 'Sťažnosť');
                    break;
                case 'move_delivery':
                    formData.append('message', 'Predĺženie úložnej doby zásielky');
                    break;
                case 'gdpr_application':
                    formData.append('message', 'Uplatnenie práv subjektov údajov (GDPR)');
                    break;
                default:
                    formData.append('message', 'Podarilo sa mu nevybrat ziadnu akciu');
            }
        }
        for(const email of values.email.split(',')) {
            formData.append('emails[]', email);
        }

        secureFetch(getApiRoute('package', ['complaint', data.type, data.package.id]), formData, 'POST', true, false).then(json => {
            if (data.type === 'damaged_shipment')
                setSending(null);
            else {
                setSending(null);
                switch (values.shipment_service) {
                    case 'location_shipment':
                        window.open('https://www.packeta.sk/kontaktny-formular?o1=98&o2=100');
                        break;
                    case 'data_change':
                        window.open('https://www.packeta.sk/kontaktny-formular?o1=98&o2=103');
                        break;
                    case 'cod':
                        window.open('https://www.packeta.sk/kontaktny-formular?o1=98&o2=102');
                        break;
                    case 'complaint':
                        window.open('https://www.packeta.sk/kontaktny-formular?o1=98&o2=111');
                        break;
                    case 'move_delivery':
                        window.open('https://www.packeta.sk/kontaktny-formular?o1=98&o2=115');
                        break;
                    case 'gdpr_application':
                        window.open('https://www.packeta.sk/kontaktny-formular?o1=98&o2=468');
                        break;
                    default:
                        break;
                }
            }
        });
    };

    return (
            <form
                autoComplete="off"
                className={clsx(classes.root, className)}
                onSubmit={handleSubmit}
                {...rest}
            >
                { data.type === 'damaged_shipment' ?
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12}>
                        <Alert severity="warning" className={classes.yMargin}>
                            <strong>Upozornenie:</strong> Reklamáciu je potrebné podať cez osobitný reklamačný formulár <strong>Packety</strong> viažuci sa ku
                            danému balíku. Po kliknutí na tlačidlo odoslať, Vám vygenerujeme a dopošleme link k tomuto
                            reklamačnému formuláru.
                        </Alert>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={t('label.message')}
                            name="message"
                            onChange={handleChange}
                            value={values.message || 'Žiadame o zaslanie linku pre reklamačný formulár predmetnej zásielky.'}
                            required
                            multiline
                            rows={3}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={t('label.email')}
                            name="email"
                            onChange={handleChange}
                            value={values.email || ''}
                            required
                        />
                    </Grid>
                </Grid> :
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12}>
                            <Alert severity="warning" className={classes.yMargin}>
                                <strong>Upozornenie:</strong> Vašu požiadavku je potrebné vyplniť cez osobitný formulár <strong>Packety</strong>. Prosím vyberte jednu z
                                položiek nižšie podľa typu Vašej požiadavky. Po kliknutí budete presmerovaný na daný
                                formulár.
                            </Alert>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Zvoľte Vašu požiadavku</FormLabel>
                                <RadioGroup aria-label="shipment_service" name="shipment_service" value={values.shipment_service } onChange={handleChange}>
                                    <FormControlLabel value="location_shipment" control={<Radio />} label="Kde je zásielka" />
                                    <FormControlLabel value="data_change" control={<Radio />} label="Zmena údajov" />
                                    <FormControlLabel value="cod" control={<Radio />} label="Dobierka" />
                                    <FormControlLabel value="complaint"  control={<Radio />} label="Sťažnosť" />
                                    <FormControlLabel value="move_delivery"  control={<Radio />} label="Predĺženie úložnej doby zásielky" />
                                    <FormControlLabel value="gdpr_application"  control={<Radio />} label="Uplatnenie práv subjektov údajov (GDPR)" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                }
                <Box display="flex" justifyContent="flex-start" py={2}>

                    {
                        sending === null ?
                        <Alert variant="filled" severity="success">
                            {t('messages.sended')}
                        </Alert> :

                            <Button color="primary" variant="contained" type="submit" disabled={sending}>
                            {t('button.send')}
                            {
                                sending && <CircularProgress size={24} color="primary" />
                            }
                        </Button>
                    }
                </Box>
            </form>
    );
};

export default ComplaintFormPacketa;
